const embalagens = [
    {
        'id': 0,
        'nome': 'Animais'
    },
    {
        'id': 1,
        'nome': 'Big Bag'
    },
    {
        'id': 2,
        'nome': 'Bobina'
    },
    {
        'id': 3,
        'nome': 'Caixas'
    },
    {
        'id': 4,
        'nome': 'Contêiner'
    },
    {
        'id': 5,
        'nome': 'Diversos'
    },
    {
        'id': 6,
        'nome': 'Fardos'
    },
    {
        'id': 7,
        'nome': 'Fracionada'
    },
    {
        'id': 8,
        'nome': 'Granel'
    },
    {
        'id': 9,
        'nome': 'Metro Cúbico'
    },
    {
        'id': 10,
        'nome': 'Milheiro'
    },
    {
        'id': 11,
        'nome': 'Mudança'
    },
    {
        'id': 12,
        'nome': 'Paletes'
    },
    {
        'id': 13,
        'nome': 'Passageiro'
    },
    {
        'id': 14,
        'nome': 'Sacos'
    },
    {
        'id': 15,
        'nome': 'Tambor'
    },
    {
        'id': 16,
        'nome': 'Unidades'
    }
]

export default embalagens


// WEBPACK FOOTER //
// ./src/vuex/cache/embalagens.js